<template>
  <li class="list-group-item no-kits">
    <div class="row">
      <div class="col-7">
         <h3>You don't have any kits</h3>
         <p>Start your journey now by purchasing or redeeming a kit.</p>
      </div>
    </div>
  </li>
</template>

<script>
import PaymentButton from '@/components/elements/PaymentButton'
export default {
  name: 'NoKits',
  props: ['product'],
  components: {
    PaymentButton
  },
  methods: {
    onClickRedeem: function () {
      this.$emit('onRedeem')
    }
  }
}
</script>

<style scoped lang='scss'>
  .no-kits{
    justify-content: center;
  }
  h4{
    line-height: 45px;
      margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/noKits.vue